<template>
  <div>
    <div class="titleAnimationPosition">
      <h2 class="mr-5">What's new</h2>
      <dotAnimation class="ml-2" />
      <v-spacer />
      <add-button
        v-if="canManageEnvironment"
        name="new entry"
        icon-title="new entry"
        route-name="roadmap_add"
        :disabled="false"
      />
    </div>
    <div class="centeredRoadmap">
      <div class="roadmapTree">
        <div
          v-for="roadmap_item in roadmap_items"
          :key="roadmap_item.id"
          class="post"
        >
          <div class="iconPosition">
            <gradient-chip v-if="roadmap_item.upcoming" text="Coming soon" />
            <v-btn
              v-if="canManageEnvironment"
              icon
              class="ml-3"
              :to="{
                name: 'roadmap_form',
                params: {
                  id: roadmap_item.id,
                  action: 'edit',
                  text: roadmap_item.content,
                },
              }"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </div>
          <div class="postText">
            <div class="postText" v-html="roadmap_item.content" />
            <div v-show="canManageEnvironment" class="sequenceNr">
              Sequence nr: {{ roadmap_item.sequence_nr }}
            </div>
          </div>
          <div class="borderLine" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AddButton from '@/components/addButton.vue'
import dotAnimation from '@/components/DotAnimation.vue'
import api from '@/api'
import { PERMISSIONS } from '@/constants/permissions'
import { useUserStore } from '@/stores/UserStore'
import GradientChip from '@/components/GradientChip.vue'

export default {
  components: { AddButton, dotAnimation, GradientChip },
  data() {
    return {
      content: '',
      roadmap_items: [],
    }
  },

  computed: {
    canManageEnvironment() {
      return this.userStore.can(PERMISSIONS.MANAGE_ENVIRONMENTS)
    },
  },

  mounted() {
    this.fetchRoadmap()
  },

  methods: {
    fetchRoadmap() {
      api.get('patch-note', { _global: true }).then((response) => {
        this.loading = false
        this.roadmap_items = response.data.reverse()
      })
    },
  },

  setup() {
    const userStore = useUserStore()
    return {
      userStore,
    }
  },
}
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/_variables.scss';

.titleAnimationPosition {
  display: flex;
  flex-direction: row;
  align-items: baseline;
  justify-content: left;
}

.borderLine {
  background-color: $primary;
  height: 75%;
  width: 2px;
  border-radius: 3px;
  flex-shrink: 0;
}

.sequenceNr {
  font-size: 0.8rem !important;
  font-style: italic;
}

.centeredRoadmap {
  display: flex;
  justify-content: center;
}

.postText {
  width: 100%;
  display: block;
}

.roadmapTree {
  display: flex;
  flex-direction: column;
  margin-top: 80px;
  margin-bottom: 80px;
  width: 100%;
  max-width: 110rem;

  @mixin milestone {
    position: absolute;
    border-radius: 100%;
    top: calc(50% - 15px);
    content: '';
    background: $primary;
    height: 30px;
    width: 30px;
  }

  @mixin post {
    width: 50%;
    position: relative;
    padding: 3rem;
    display: flex;
    gap: 1.5rem;
    align-items: center;
    justify-content: space-between;
  }

  @mixin timeLine {
    top: 0;
    content: '';
    height: 100%;
    width: 4px;
    position: absolute;
    background: #e0e0e0;
  }

  .post {
    gap: 1.5rem;
  }

  .iconPosition {
    display: flex;
    height: 100%;
  }

  .post:nth-child(odd) {
    @include post;
    align-self: start;
    flex-direction: row-reverse;

    &::before {
      @include timeLine;
      right: 0;
    }

    &:after {
      @include milestone;
      right: -13px;
    }
  }

  .post:nth-child(even) {
    @include post;
    align-self: end;
    flex-direction: row;

    &::before {
      @include timeLine;
      left: -4px;
    }

    &::after {
      @include milestone;
      left: -18px;
    }
  }

  .post:hover {
    background-color: #f0f0f0;
  }
}
</style>
